export const InstrumentType = {
    Revio: "Revio",
    Vega: "Vega",
    Orca: "Orca"
} as const
// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
export type InstrumentType = (typeof InstrumentType)[keyof typeof InstrumentType]
export type ChipType = "AllChips" | "25mChip" | "100mChip"

export const isRevio = (s: string, flags?: {isPermissive: boolean}): boolean => {
    if (s === "Revio") return true
    if (flags && flags.isPermissive) {
        if (s === "revio") return true
    }
    return false
}

export const isVega = (s: string): boolean => {
    return s === "Vega"
}

export const isOrca = (s: string): boolean => {
    return s === "Orca"
}

export const InstrumentTypeToCorrectedTypeMap = {
    "Revio": "Revio",
    "revio": "Revio",
}

export const InstrumentTypeToDisplayNameMap = {
    Revio: "Revio",
    Vega: "Vega",
    Orca: "Orca"
}

const InstrumentTypeToChipTypeMap = {
    Revio: "25mChip",
    Vega: "25mChip",
    Orca: "100mChip"
}
const ChipTypeToDefaultInstrumentTypeMap = {
    "25mChip": "Revio",
    "100mChip": "Orca"
}

// Total number of ZMWs on the chip, which depends on the instrument type
const InstrumentTypeToMaxZmwsMap = {
    Revio: 25000000,
    Vega: 25000000,
    Orca: 100000000
}

export function getDisplayNameForInstrumentType(instrumentType: InstrumentType) {
    const result = InstrumentTypeToDisplayNameMap[instrumentType]
    if (!result) { throw new Error("getDisplayNameForInstrumentType: Unexpected instrument type: " + instrumentType) }
    return result
}

export function getChipTypeForInstrumentType(instrumentType: InstrumentType): ChipType {
    const result = InstrumentTypeToChipTypeMap[instrumentType]
    if (!result) { throw new Error("getChipTypeForInstrumentType: Unexpected instrument type: " + instrumentType) }
    return result as ChipType
}

export function getMaxZmwsForInstrumentType(instrumentType: InstrumentType): number {
    const result = InstrumentTypeToMaxZmwsMap[instrumentType]
    if (!result) { throw new Error("getMaxZmwsForInstrumentType: Unexpected instrument type: " + instrumentType) }
    return result
}

// This function is only for when the instrument type is not know and a legacy mapping can be assumed
export function getDefaultInstrumentTypeForChipType(chipType: ChipType): InstrumentType {
    // Old legacy items (e.g. Sequel chip types) are assumed to be Revio
    return ChipTypeToDefaultInstrumentTypeMap[chipType] ?? "Revio"
}

export const instrumentTypeBySerial = (serial: string): InstrumentType => {
    if (serial.startsWith("8")) {
        return "Revio"
    }
    return null
}
